import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=6267941a&lang=pug"
import script from "./Coupons.vue?vue&type=script&lang=coffee"
export * from "./Coupons.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports